(function () {
  if (window.__ncGkCartClear) return;
  window.__ncGkCartClear = true;

  var KEY = 'ncGkOrderOk';
  var seq = 0;

  function read(k) {
    try {
      return sessionStorage.getItem(k);
    } catch (e) {
      return null;
    }
  }

  function write(k, v) {
    try {
      if (v == null) sessionStorage.removeItem(k);
      else sessionStorage.setItem(k, v);
    } catch (e) {}
  }

  function kind() {
    if (window.__ncGkNav === 'buyNow' || window.__ncGkNav === 'checkout')
      return window.__ncGkNav;
    return read('ncGkKind');
  }

  function cartUrl() {
    return (window.routes && routes.cart_url) || '/cart';
  }

  function restoreSnap() {
    var snap;
    try {
      snap = JSON.parse(read('ncGkSnap') || '[]');
    } catch (e) {
      snap = [];
    }
    if (!snap.length) return Promise.resolve();
    var cart = cartUrl();
    return fetch(cart + '.js', { credentials: 'same-origin' })
      .then(function (r) {
        return r.json();
      })
      .then(function (data) {
        if (data.item_count) return;
        var items = [];
        for (var i = 0; i < snap.length; i++) {
          var id = snap[i].variant_id || snap[i].id;
          if (id) items.push({ id: id, quantity: snap[i].quantity || 1 });
        }
        if (!items.length) return;
        return fetch(cart.replace(/\/?$/, '') + '/add.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: items }),
        });
      });
  }

  function paint(sections) {
    var dst = document.querySelector('cart-drawer');
    if (dst && sections['cart-drawer']) {
      var src = new DOMParser()
        .parseFromString(sections['cart-drawer'], 'text/html')
        .querySelector('cart-drawer');
      if (src) {
        var from = src.querySelector('#CartDrawer');
        var to = dst.querySelector('#CartDrawer');
        if (from && to) to.innerHTML = from.innerHTML;
        dst.classList.toggle('is-empty', src.classList.contains('is-empty'));
      }
    }
    var bubble = document.getElementById('cart-icon-bubble');
    if (bubble && sections['cart-icon-bubble']) {
      var doc = new DOMParser().parseFromString(
        sections['cart-icon-bubble'],
        'text/html',
      );
      bubble.innerHTML = (
        doc.querySelector('.shopify-section') || doc.body
      ).innerHTML;
    }
  }

  function refresh(canClear) {
    var n = ++seq;
    var cart = cartUrl();
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    var ready = canClear
      ? fetch(cart + '.js')
          .then(function (r) {
            return r.json();
          })
          .then(function (data) {
            if (n !== seq || !data.item_count) return;
            return fetch(cart.replace(/\/?$/, '') + '/clear.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: '{}',
            });
          })
      : Promise.resolve();

    ready
      .then(function () {
        if (n !== seq) return;
        return fetch(root + '?sections=cart-drawer,cart-icon-bubble');
      })
      .then(function (r) {
        return r && r.json ? r.json() : null;
      })
      .then(function (sections) {
        if (n !== seq || !sections) return;
        paint(sections);
        if (canClear) write(KEY);
      })
      .catch(function () {});
  }

  function restoreThenReload() {
    restoreSnap().finally(function () {
      write('ncGkDidRestore', '1');
      location.reload();
    });
  }

  window.addEventListener('message', function (e) {
    if (
      e.origin !== location.origin &&
      String(e.origin).indexOf('gokwik.') === -1
    )
      return;
    var d = e.data;
    if (!d || typeof d !== 'object') return;
    var name = d.response && d.response.name;
    if (
      d.type !== 'clear_cart' &&
      d.type !== 'orderSuccess' &&
      name !== 'orderSuccess' &&
      name !== 'order_success'
    ) {
      return;
    }
    var k = kind();
    if (k !== 'buyNow' && k !== 'checkout') return;
    write(KEY, k === 'checkout' ? 'cart' : 'buyNow');
    if (k === 'checkout') refresh(true);
    else restoreSnap();
  });

  window.addEventListener(
    'pageshow',
    function (e) {
      if (read('ncGkDidRestore')) {
        write('ncGkDidRestore');
        write('ncGkSnap');
        write(KEY);
        return;
      }

      var nav =
        performance.getEntriesByType &&
        performance.getEntriesByType('navigation')[0];
      var isBack = e.persisted || (nav && nav.type === 'back_forward');

      if (isBack && kind() === 'buyNow' && read(KEY) === 'buyNow') {
        restoreThenReload();
        return;
      }

      if (!e.persisted || !window.__ncGkNav) return;
      refresh(window.__ncGkNav === 'checkout' && read(KEY) === 'cart');
    },
    true,
  );
})();
